import { useTranslation } from 'react-i18next'
import type { LearnerStatusCode } from '@/api/learnerStatus'

const BADGE_CLASSES: Record<LearnerStatusCode, string> = {
  WAITING: 'bg-gray-100 text-gray-700',
  ENROLLED: 'bg-green-100 text-green-700',
  ON_LEAVE: 'bg-orange-100 text-orange-700',
  WITHDRAWN: 'bg-red-100 text-red-700',
}

/** Derived learner status badge (WAITING/ENROLLED/ON_LEAVE/WITHDRAWN) — shared by member/enrollment pages */
export function MemberStatusBadge({ status }: { status: LearnerStatusCode }) {
  const { t } = useTranslation(['admin'])
  return (
    <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${BADGE_CLASSES[status]}`}>
      {t(`admin:students.memberStatus.${status}`, { defaultValue: status })}
    </span>
  )
}
